/**
 * Invoice Download Service
 */

import api from "../../../shared/api.jsx";

class InvoiceDownloadService {
  /**
   * Download invoice PDF
   * @param {string} invoiceId - Invoice ID
   * @returns {Promise<void>}
   */
  async downloadPdf(invoiceId) {
    try {
      const url = `/invoices/${invoiceId}/pdf`;
      const response = await api.binary(url, {}, "application/pdf");

      // Get filename from Content-Disposition header or use default
      const contentDisposition = response.headers.get("Content-Disposition");
      let filename = `invoice_${invoiceId || "unknown"}_summary.pdf`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      // Create blob and download
      const blob = await response.blob();
      this.downloadBlob(blob, filename);
    } catch (error) {
      console.error("PDF download failed:", error);
      throw error;
    }
  }

  /**
   * Download blob as file
   * @param {Blob} blob - Blob to download
   * @param {string} filename - Filename for download
   */
  downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
}

export const invoiceDownloadService = new InvoiceDownloadService();

